import { forwardRef } from 'react';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

/**
 * Avoid @mui/lab LoadingButton forwarding `loading` to the native <button> (React DOM warning).
 */
const LoadingButton = forwardRef(function LoadingButton(
  { loading = false, disabled, children, startIcon, endIcon, sx, ...props },
  ref,
) {
  const isLoading = Boolean(loading);

  return (
    <Button
      ref={ref}
      disabled={disabled || isLoading}
      startIcon={isLoading ? <CircularProgress color='inherit' size={16} /> : startIcon}
      endIcon={endIcon}
      sx={{ position: 'relative', ...sx }}
      {...props}
    >
      {children}
    </Button>
  );
});

LoadingButton.displayName = 'LoadingButton';

export default LoadingButton;
